/* differ* — NERV learnings, 24 Sep 2026. Homepage only.

   1. Early reveal. theme.js reveals a block once it is already on screen, so
      a fast scroller used to meet an empty or foggy block. This switches each
      block on a little before it arrives. Same class theme.js uses, so
      nothing else changes. */
(function () {
  'use strict';

  function earlyReveal() {
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('[data-animate].differ-reveal:not(.is-visible)');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 25% 0px', threshold: 0 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 2. The archive card sign-up (Change D). The card holds the same waitlist
        form as the hero, so it posts to the same Shopify customer form, with
        the same tags pattern and the same error text, and it goes through the
        same Shopify bot check (hCaptcha) first.

        How: Shopify's bot check stops the submit, gets its token, then calls
        the form's own submit(). Here that last step sends the form in the
        background instead of reloading the page, so the card can swap in
        place. If the bot check is off, the form simply posts normally, like
        the hero. If anything unexpected comes back, it posts normally too,
        token and all, so a sign-up is never lost. */
  function archiveCard() {
    var card = document.querySelector('[data-differ-card]');
    if (!card) return;
    var before = card.querySelector('[data-differ-card-before]');
    var after = card.querySelector('[data-differ-card-after]');
    var live = card.querySelector('[data-differ-card-live]');
    if (!before || !after) return;

    function markDone(moveFocus) {
      before.hidden = true;
      after.hidden = false;
      if (live) live.textContent = after.textContent.replace(/\s+/g, ' ').trim();
      /* Same flag the gate sets when it sees a receipt after a reload. */
      try { localStorage.setItem('differFounderIn', '1'); } catch (e) { /* private mode */ }
      try { sessionStorage.removeItem('differWaitlistSource'); } catch (e) { /* private mode */ }
      var bar = document.querySelector('[data-differ-stickybar]');
      if (bar) {
        bar.classList.remove('is-active');
        document.documentElement.classList.remove('differ-stickybar-on');
        bar.hidden = true;
      }
      if (moveFocus) { try { after.focus({ preventScroll: true }); } catch (e) { /* old browser */ } }
    }

    /* Someone just signed up the ordinary way (any form, page reloaded): the
       card tells the same story. */
    if (document.querySelector('[data-differ-wl-confirm]')) { markDone(false); return; }

    var form = before.querySelector('form');
    if (!form || !window.fetch || !window.FormData || !window.DOMParser) return;

    var nativeSubmit = HTMLFormElement.prototype.submit;
    var sending = false;

    function showError(text) {
      var err = form.querySelector('.differ-ch-batch__error');
      if (!err) {
        err = document.createElement('p');
        err.className = 'differ-ch-batch__error';
        err.setAttribute('role', 'alert');
        form.appendChild(err);
      }
      err.textContent = text;
    }

    function fallback() {
      try { sessionStorage.setItem('differWaitlistSource', form.id); } catch (e) { /* private mode */ }
      nativeSubmit.call(form);
    }

    /* Installed before the bot check binds to the form, which happens when
       the visitor first clicks into the field. */
    form.submit = function () {
      if (sending) return;
      sending = true;
      var button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      function reset() {
        sending = false;
        if (button) button.disabled = false;
        form.removeAttribute('aria-busy');
      }

      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (res) {
          return res.text().then(function (html) { return { res: res, html: html }; });
        })
        .then(function (r) {
          var url = r.res.url || '';
          if (!r.res.ok || url.indexOf('/challenge') !== -1) throw new Error('fallback');
          var doc = new DOMParser().parseFromString(r.html, 'text/html');
          var echo = doc.getElementById(form.id);
          if (url.indexOf('customer_posted=true') !== -1 || (echo && echo.querySelector('[data-differ-wl-confirm]'))) {
            reset();
            markDone(true);
            return;
          }
          var err = echo && echo.querySelector('.differ-ch-batch__error');
          if (err) {
            showError(err.textContent.trim());
            reset();
            return;
          }
          throw new Error('fallback');
        })
        .catch(function () { fallback(); });
    };
  }

  function init() {
    earlyReveal();
    archiveCard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
